import * as React from 'react';

import { EnvHeader } from '../common/env-header';
import { HeaderDrawerButton } from './header-drawer-button';
import { HeaderUserName } from './header-user-name';
import { Notifications } from './notifications';
import { OrbitButton } from './orbit-button';
import { SearchBox } from './search-box';

interface HeaderProps {
    title: JSX.Element | string;
    actions?: React.ReactNode[];
    children?: React.ReactNode;
}

export const Header: React.FC<HeaderProps> = ({ title, actions, children }) => {
    return (
        <div className="flex-fixed" id="page-header">
            <EnvHeader />
            <div className="page-header-primary">
                <div className="header-left">
                    <div className="header-left-menu">
                        <HeaderDrawerButton />
                    </div>
                    <div className="header-title">{title}</div>
                </div>
                <div className="header-right">
                    {actions}
                    <SearchBox />
                    <OrbitButton />
                    <HeaderUserName />
                    <Notifications />
                </div>
            </div>
            <div className="page-header-secondary">{children}</div>
        </div>
    );
};
